// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolsbarfulldiv
{
    width:89%;
    height: calc (100% - 4px);
    background-color: var(--toolsbar-backcolor);
    margin-top: 2px;
    margin-bottom: 2px;
    border-width: var(--toolsbar-borderwidth);
    border-color: var(--toolsbar-bordercolor);
    border-style: var(--toolsbar-borderstyle);
    text-align: left;
    padding-left: 11%;
  }

  .toolsbarfulldivNoBackGround
  {
    width:89%;
    height: calc (100% - 4px);
    background-color: transparent;
    margin-top: 2px;
    margin-bottom: 2px;
    border-width: var(--toolsbar-borderwidth);
    border-color: var(--toolsbar-bordercolor);
    border-style: var(--toolsbar-borderstyle);
    text-align: left;
    padding-left: 11%;

  }

  .toolsbar-flexdiv
  {
    
    display: flex;
  }

  .toolsbar-flexdiv-family
  {
    
    margin-left: 10px;
    background-color: #101030;
    border-radius: 3px;
  }

  .toolsbar-flexdiv-title
  {
    
    text-align: center;
    font-size: 10px;
    border-radius: 3px;
    background-color: #202020;
  }  
  
  .toolsbar-flexdiv-button
  {
    padding-top: 2px;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./src/components/bases/toolsbar/toolsbar.css"],"names":[],"mappings":"AAAA;;IAEI,SAAS;IACT,yBAAyB;IACzB,2CAA2C;IAC3C,eAAe;IACf,kBAAkB;IAClB,yCAAyC;IACzC,yCAAyC;IACzC,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,SAAS;IACT,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,yCAAyC;IACzC,yCAAyC;IACzC,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;;EAEnB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;;;IAGE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;;;IAGE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB","sourcesContent":[".toolsbarfulldiv\n{\n    width:89%;\n    height: calc (100% - 4px);\n    background-color: var(--toolsbar-backcolor);\n    margin-top: 2px;\n    margin-bottom: 2px;\n    border-width: var(--toolsbar-borderwidth);\n    border-color: var(--toolsbar-bordercolor);\n    border-style: var(--toolsbar-borderstyle);\n    text-align: left;\n    padding-left: 11%;\n  }\n\n  .toolsbarfulldivNoBackGround\n  {\n    width:89%;\n    height: calc (100% - 4px);\n    background-color: transparent;\n    margin-top: 2px;\n    margin-bottom: 2px;\n    border-width: var(--toolsbar-borderwidth);\n    border-color: var(--toolsbar-bordercolor);\n    border-style: var(--toolsbar-borderstyle);\n    text-align: left;\n    padding-left: 11%;\n\n  }\n\n  .toolsbar-flexdiv\n  {\n    \n    display: flex;\n  }\n\n  .toolsbar-flexdiv-family\n  {\n    \n    margin-left: 10px;\n    background-color: #101030;\n    border-radius: 3px;\n  }\n\n  .toolsbar-flexdiv-title\n  {\n    \n    text-align: center;\n    font-size: 10px;\n    border-radius: 3px;\n    background-color: #202020;\n  }  \n  \n  .toolsbar-flexdiv-button\n  {\n    padding-top: 2px;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
